<div class="d-flex text-end justify-content-between align-items-center">
  <h2>Hold By Property</h2>
</div>
<ag-grid-angular
	style="width: auto; height: auto; margin: 20px 0px;"
	class="ag-theme-balham"
	[gridOptions]="gridOptions"
	[rowData]="resRevMaster"
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
	[groupDefaultExpanded]="groupDefaultExpanded"
	(rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>
